import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Center, Loader } from '@mantine/core';

interface RouteGuardProps {
  children: React.ReactNode;
}

export function RouteGuard({ children }: RouteGuardProps) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export function AuthLoading() {
  return (
    <Center h="100vh">
      <Loader size="lg" />
    </Center>
  );
}
